import { render, staticRenderFns } from "./StudentScholarshipPreview.vue?vue&type=template&id=b345d562&scoped=true"
import script from "./StudentScholarshipPreview.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipPreview.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipPreview.vue?vue&type=style&index=0&id=b345d562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b345d562",
  null
  
)

export default component.exports